<template>
  <div id="app" class="app">
    <template v-if="displayLogo">
      <a target="_blank" href="https://www.protosterminal.com/">
        <img src="@/assets/images/png/logo-protos.png" class="app__logo" />
        <div class="app__logo-name"> PROTOS TERMINAL BETA </div>
      </a>
    </template>
    <div v-if="getIsLoading" class="app__sync">
        <sync-loader
            :loading="getIsLoading"
            color="blueviolet"
            height="100%"
            width="100%"
        />
      </div>
    <div v-if="displaySnackbar" class="app__snackbar">
        <default-snackbar
            :type="getSnackbar.type"
            :message="getSnackbar.message"
        />
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { SNACKBAR_TIMEOUT } from "@/constants/common";
import SyncLoader from 'vue-spinner/src/SyncLoader'
import DefaultSnackbar from "@/components/ui/shared/snackbar/DefaultSnackbar";

  export default  {
    name: "App",
    components: { DefaultSnackbar, SyncLoader },
    computed: {
      ...mapGetters({
        getIsLoading: 'getIsLoading',
        getSnackbar: 'getSnackbar',
        displaySnackbar: 'displaySnackbar'
      }),
      displayLogo() {
        return !this.$route.fullPath.includes('profile')
      }
    },
    watch: {
      displaySnackbar(value) {
        if (value) {
          setTimeout(() => {
            this.hideSnackbar()
          }, SNACKBAR_TIMEOUT)
        }
      }
    },
    methods: {
      ...mapActions({
        hideSnackbar: 'hideSnackbar'
      })
    }
  }
</script>

<style lang="scss">
.app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
  background: #F4F7F8;

  &__logo {
    width: 16rem;
    position: absolute;
    left: 0.5rem;
    top: 0.5rem;
  }

  &__logo-name {
    width: 16rem;
    position: absolute;
    left: 2.5rem;
    margin-top: 4.25rem;
    font-size: 0.75rem;
    color: gray;
  }

  &__sync {
    width: 100vw;
    height: 100vh;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  &__snackbar {
    transition: all linear 0.2s;
  }

}

@media (max-width: 425px) {
  .app {
    width: fit-content;
  }
}

body {
  margin: 0;
  background-color: #F4F7F8;
  height: auto;
}

</style>

